<template>
  <div>
    <div v-for="(item, index) in items" :key="index" class="row" @click="targetWalletDraftState.target_wallet = item">
      <sb-checkbox :checked="targetWalletDraftState.target_wallet === item" :data-cy="`target-wallet-${item.replace(/\s+/g, '-')}-input`" /> {{ item }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'


export default {
  props: {
    targetWalletDraftState: Object
  },

  name: "target-wallet-form",

  computed: {
    items: function () {
      let options = ["interests", "birthday", "profile", "home"]
      if (this.currentMerchant.active_referral_program) { options.unshift('referral') }
      if (this.currentMerchant.website) { options.push('shop online') }
      return options
    },

    ...mapGetters(['currentMerchant']),
  },
}
</script>